// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  origin: 'https://ent.wetrackon.com/',
  // AES key for login-payload encryption — must match server app.config.json `login_enc_key`.
  login_enc_key: 'f50b61d656349ba94e1b6d4528784018',

  // Audit obs #2 (CWE-269) - MenuScopeGuard staging dial. Raised to 'logout' on
  // 2026-08-19 at the client's explicit request, after 'redirect' was confirmed
  // working: the audited PoC (State user pasting /internal/ams_vehicles/add_newvehcile)
  // is refused, and the session is now ended rather than bounced to the dashboard.
  //
  // THE COST, ACCEPTED DELIBERATELY: a stale bookmark, a shared deep link or an old
  // tab now ends a session mid-task and loses unsaved work. 'redirect' achieves the
  // same "do not show the page" outcome without that. Drop back to 'redirect' if
  // support starts seeing unexplained logouts - it is a one-word change here.
  //
  // Safe for the 1,480 of 6,889 active user rows that carry no app_prfle_id:
  // MenuScopeService.isPermitted() fails OPEN on an empty route set, so an
  // unresolvable profile still navigates. Only a profile that resolves to a
  // non-empty set NOT containing the target is refused - which is the rule.
  //
  // This is a UI control, NEVER a security boundary. The API is reachable without
  // the browser, so the server-side vld*(object) gates remain the control that
  // actually refuses a privileged write. Do not cite this dial as closing obs #2.
  menuScope: { mode: 'logout' as 'off' | 'report' | 'redirect' | 'logout' }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
